import React, {
  memo,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import {
  Box,
  Flex,
  Input,
  InputGroup,
  InputRightElement,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Thead,
  Tr,
  HStack,
  Img,
  Button,
  Image,
  MenuItem,
  MenuList,
  MenuButton,
  Menu,
  useDisclosure,
  Skeleton,
  Modal,
  ModalOverlay,
  ModalContent,
  Checkbox,
} from "@chakra-ui/react";
import { SearchIcon } from "@chakra-ui/icons";
import { formatTableValue } from "./formatTable";
import chevronLeft from "../../assets/images/employee/chevron-left.svg";
import chevronRight from "../../assets/images/employee/chevron-right.svg";
import ReactPaginate from "react-paginate";
import iconEdit from "../../assets/images/product/edit.svg";
import iconDetail from "../../assets/images/contract/Frame (1).svg";
import iconArrowLeft from "../../assets/images/arrow-left.svg";
import { AiOutlineMore } from "react-icons/ai";
import SearchableSelect from "../../components/selectForm";
import { useTtkq } from "../../hooks/useTtkq";
import useDebounce from "../../hooks/useDebounce";
import { useCategories } from "../../categorys/contract/index";
import toast from "react-hot-toast";
import { ttkqCall } from "../../api/ttkq";
import FormInfo from "./form/info";
import FormDetail from "./form/detail";
// import { commonCall } from "../../api/common";
import FormCreateSaleContract from "./form/createSaleContract";
import { contractCall } from "../../api/contract";
import { StatusData } from "../../utils/globalVariable";
import SearchableSelectMulti from "../../components/selectForm/mutiSelect";
import DatePicker from "react-datepicker";
import calendarIcon from "../../assets/images/onleave/calendar.svg";
import IconX from "../../assets/images/booking/x-circle.svg";
import FormReport from "./form/report";
const baseURL = process.env.REACT_APP_BACKEND_API || "http://localhost:3001";

const TableOpenTtkq = ({ isRefetchingWithCreate, paramData }) => {
  const { isOpen, onOpen, onClose, onToggle } = useDisclosure();
  const {
    isOpen: isOpenTypeImage,
    onOpen: onOpenTypeImage,
    onClose: onCloseTypeImage,
  } = useDisclosure();
  const {
    isOpen: isOpenReport,
    onOpen: onOpenReport,
    onClose: onCloseReport,
    // onToggle: onToggleReport,
  } = useDisclosure();

  const statusDatas = [
    {
      key: "NEW",
      value: "Chưa duyệt",
    },
    {
      key: "REJECTED",
      value: "Không được phê duyệt",
    },
    {
      key: "APPROVED",
      value: "Đã được duyệt",
    },
  ];

  const {
    isOpen: isOpenHDMB,
    onOpen: onOpenHDMB,
    onClose: onCloseHDMB,
    onToggle: onToggleHDMB,
  } = useDisclosure();

  const [isEdit, setIsEdit] = useState(false);
  const [search, setSearch] = useState("");
  const [projectId, setProjectId] = useState(null);
  const [employeeId, setEmployeeId] = useState(null);
  const [dataEdit, setDataEdit] = useState(null);
  const [shouldFetch, setShouldFetch] = useState(false);
  const [status, setStatus] = useState(null);
  const [apartmentId, setApartmentId] = useState([]);
  const [customerId, setCustomerId] = useState(null);
  const [zIndex, setZIndex] = useState(1);
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  const [saleBlockId, setSaleBlockId] = useState(null);
  const [saleAreaId, setSaleAreaId] = useState(null);
  const [dataId, setDataId] = useState(null);
  const [typeImage, setTypeImage] = useState([]);

  const debouncedSearchTerm = useDebounce(search, 500);
  const onChangeSearch = useCallback((e) => {
    const { value } = e.target;
    setSearch(value);
  });

  const {
    ttkqData,
    refetch,
    isLoading,
    isRefetching,
    totalPages,
    setCurrentPage,
    currentPage,
    entries,
    startEntry,
    endEntry,
  } = useTtkq(
    debouncedSearchTerm,
    projectId,
    employeeId,
    status,
    apartmentId,
    customerId,
    startDate,
    endDate,
    saleBlockId,
    saleAreaId
  );

  // refech create
  function usePrevious(value) {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    }, [value]);
    return ref.current;
  }
  const prevIsRefetchingWithCreate = usePrevious(isRefetchingWithCreate);
  useEffect(() => {
    if (
      isRefetchingWithCreate &&
      prevIsRefetchingWithCreate !== isRefetchingWithCreate
    ) {
      refetch();
    }
  }, [isRefetchingWithCreate, prevIsRefetchingWithCreate, refetch]);

  useEffect(() => {
    paramData({
      search: debouncedSearchTerm,
      projectId,
      employeeId,
      status,
      apartmentId,
      customerId,
      startDate,
      endDate,
      saleBlockId,
      saleAreaId,
    });
  }, [
    paramData,
    debouncedSearchTerm,
    projectId,
    employeeId,
    status,
    apartmentId,
    customerId,
    startDate,
    endDate,
    saleBlockId,
    saleAreaId,
  ]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShouldFetch(true);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  const { constantData } = useCategories(shouldFetch);

  const formatEntries = (entries) =>
    Object.entries(entries || {}).map(([key, value]) => ({ key, value }));

  const projects = useMemo(
    () => formatEntries(constantData?.project),
    [constantData?.project]
  );

  const employees = useMemo(
    () => formatEntries(constantData?.employee),
    [constantData?.employee]
  );
  const apartments = useMemo(
    () => formatEntries(constantData?.apartments),
    [constantData?.apartments]
  );
  const customers = useMemo(
    () => formatEntries(constantData?.customer),
    [constantData?.customer]
  );

  const saleAreas = useMemo(
    () => formatEntries(constantData?.saleArea),
    [constantData?.saleArea]
  );
  const saleBlocks = useMemo(
    () => formatEntries(constantData?.saleBlock),
    [constantData?.saleBlock]
  );

  const handlePageChange = (selectedPage) => {
    setCurrentPage(selectedPage.selected + 1);
    refetch();
  };

  const tableData = {
    headers: [
      {
        label: "",
        key: "",
      },
      {
        label: "STT",
        key: "",
      },
      {
        label: "Trạng thái",
        key: "status",
      },
      {
        label: "Ảnh UNC",
        key: "delegationImage",
      },
      {
        label: "Ảnh Phiếu Tính Giá",
        key: "priceSheetImage",
      },
      {
        label: "Ảnh TTKQ",
        key: "salesContractImages",
      },
      // {
      //   label: "Mã TTKQ",
      //   key: "code",
      // },
      {
        label: "Dự án",
        key: "name",
      },
      {
        label: "Mã sản phẩm (mã căn)",
        key: "apartment",
      },
      // {
      //   label: "Tên sản phẩm",
      //   key: "nameApartment",
      // },
      {
        label: "Tên khách hàng",
        key: "customer",
      },
      {
        label: "Ngày ký TTKQ",
        key: "time",
      },
      // {
      //   label: "Phiếu tính giá",
      //   key: "invoice",
      // },
      // {
      //   label: "Phương thức thanh toán",
      //   key: "paymentMethod",
      // },
      // {
      //   label: "Số tiền đóng TTKQ",
      //   key: "price",
      // },
      {
        label: "Ngày đóng tiền TTKQ",
        key: "priceTime",
      },
      {
        label: "Người tham gia giao dịch",
        key: "participants",
      },
      {
        label: "Người chuyển TTKQ",
        key: "creator",
      },
      {
        label: "Khối",
        key: "saleBlock",
      },
      {
        label: "Vùng",
        key: "saleArea",
      },
      // {
      //   label: "Đại lý",
      //   key: "agentName",
      // },
      {
        label: "Ngày chuyển TTKQ",
        key: "createdAt",
      },
    ],
    data: ttkqData,
  };

  const handlePopup = (type, e) => {
    if (type) {
      setDataEdit(e?.edit);
    } else {
      setDataEdit(e?.detail);
    }

    setIsEdit(type);
    onOpen();
  };

  const handleHDMB = (e) => {
    setDataEdit(e?.edit);
    onOpenHDMB();
  };

  const handleOpenReportBooking = (data) => {
    setDataEdit(data);
    onOpenReport();
  };

  const onSubmitEdit = async (data) => {
    const toastCreate = toast.loading("Đang sửa TTKQ ...");
    try {
      let filteredData = Object.fromEntries(
        Object.entries(data).filter(
          ([_, value]) => value !== "" && value !== undefined && value !== null
        )
      );
      const {
        id,
        infident1,
        infident2,
        imagePayment,
        delegationImage,
        priceSheetImage,
        salesContractImages,
        images,
        creator,
        customer,
        createdAt,
        apartment,
        project,
        note,
        ...dataFilter
      } = filteredData;

      delete dataFilter?.bookerId;

      const imagesOpition = {};
      if (delegationImage && delegationImage.length > 0) {
        imagesOpition.delegationImage = delegationImage;
      } else {
        imagesOpition.delegationImage = [];
      }

      if (priceSheetImage && priceSheetImage.length > 0) {
        imagesOpition.priceSheetImage = priceSheetImage;
      } else {
        imagesOpition.priceSheetImage = [];
      }

      if (salesContractImages && salesContractImages.length > 0) {
        imagesOpition.salesContractImages = salesContractImages;
      } else {
        imagesOpition.salesContractImages = [];
      }

      await ttkqCall.update(id, {
        ...dataFilter,
        ...imagesOpition,
      });

      await refetch();
      onToggle();
      onClose();
      toast.success("Sửa thành công");
    } catch (error) {
      console.log({ error });
      toast.dismiss(toastCreate);
    }
    toast.dismiss(toastCreate);
  };

  const submitStatus = async (status, id, transactionDate) => {
    const toastEdit = toast.loading("Đang cập nhập trạng thái ...");
    const dataFormat = {
      status: status,
    };

    // Ngày cọc (ngày giao dịch) chọn khi duyệt TTKQ; không có thì BE tự mặc định.
    if (transactionDate) {
      dataFormat.transactionDate = transactionDate;
    }

    try {
      await ttkqCall.approve(id, dataFormat);
      await refetch();
      toast.success("Cập nhập trạng thái thành công");
    } catch (error) {
      console.error("Error:", error);
      toast.error("Có lỗi xảy ra khi cập nhập trạng thái");
    }
    toast.dismiss(toastEdit);
  };

  const onSubmitCreateSaleContract = async (data) => {
    const toastCreate = toast.loading("Đang chuyển hợp đồng mua bán ...");
    try {
      let filteredData = Object.fromEntries(
        Object.entries(data).filter(
          ([_, value]) => value !== "" && value !== undefined && value !== null
        )
      );

      const {
        delegationImage,
        priceSheetImage,
        salesContractImages,
        ...dataFilter
      } = filteredData;

      const imagesOpition = {};
      if (delegationImage && delegationImage.length > 0) {
        imagesOpition.delegationImage = delegationImage;
      } else {
        imagesOpition.delegationImage = [];
      }

      if (priceSheetImage && priceSheetImage.length > 0) {
        imagesOpition.priceSheetImage = priceSheetImage;
      } else {
        imagesOpition.priceSheetImage = [];
      }

      if (salesContractImages && salesContractImages.length > 0) {
        imagesOpition.salesContractImages = salesContractImages;
      } else {
        imagesOpition.salesContractImages = [];
      }

      // if (
      //   data?.delegationImage &&
      //   Object.keys(data?.delegationImage).length !== 0
      // ) {
      //   const { filePath } = await commonCall.uploadFile(
      //     delegationImage?.file,
      //     "lockingDocument"
      //   );

      //   await contractCall.create({
      //     ...dataFilter,
      //     delegationImage: filePath || "",
      //   });
      // } else {
      //   toast.error("Vui lòng chọn ảnh ủy nhiệm chi");
      // }

      await contractCall.create({
        ...dataFilter,
        ...imagesOpition,
      });

      await refetch();
      onToggleHDMB();
      onCloseHDMB();
      toast.success("Chuyển thành công");
    } catch (error) {
      console.log({ error });
      toast.dismiss(toastCreate);
    }
    toast.dismiss(toastCreate);
  };

  const revertStatus = async (id) => {
    const toastEdit = toast.loading("Đang cập nhập trạng thái ...");

    try {
      await ttkqCall.revert(id);
      await refetch();
      toast.success("Cập nhập trạng thái thành công");
    } catch (error) {
      console.error("Error:", error);
      toast.error("Có lỗi xảy ra khi cập nhập trạng thái");
    }
    toast.dismiss(toastEdit);
  };

  const getTypeImage = async (id) => {
    const toastCreate = toast.loading("Đang lấy danh sách ảnh TTKQ ...");
    try {
      const data = await ttkqCall.getTypeImage(id);
      if (data?.items) {
        setTypeImage(data?.items);
        onOpenTypeImage();
      }
      setDataId(id);
      await refetch();
      toast.success("Lấy danh sách ảnh thành công");
    } catch (error) {
      console.log({ error });
      toast.dismiss(toastCreate);
    }
    toast.dismiss(toastCreate);
  };

  return (
    <>
      <Flex flexDirection={"column"} gap={{ base: "16px" }}>
        <Flex
          backgroundColor="var(--color-main)"
          borderRadius={{ base: "12px" }}
          flexDirection={"column"}
        >
          <Flex
            alignItems={"center"}
            justifyContent={"space-between"}
            gap={{ base: "32px" }}
            p={"16px 16px 12px 16px"}
          >
            <Flex
              alignItems={"flex-start"}
              gap={{ base: "16px 32px" }}
              flex={"1"}
              flexDirection={"column"}
            >
              <InputGroup
                maxW="42vw"
                minW={"42vw"}
                borderRadius={{ base: "8px" }}
                w={{ base: "100%" }}
              >
                <Input
                  placeholder="Nhập mã, tên TTKQ, tên dự án, sản phẩm, khách hàng..."
                  type="text"
                  borderRadius={{ base: "8px" }}
                  border={{ base: "1px solid var(--color-boder)" }}
                  backgroundColor={"var(--fill-avatar)"}
                  onChange={onChangeSearch}
                />
                <InputRightElement
                  borderTopRightRadius={"8px"}
                  borderBottomRightRadius={"8px"}
                  pointerEvents="none"
                  cursor={"pointer"}
                  backgroundImage="var(--color-button)"
                >
                  <SearchIcon color="var(--color-main)" />
                </InputRightElement>
              </InputGroup>
              <Flex
                alignItems={"center"}
                gap={{ base: "16px 32px" }}
                flex={"1"}
                flexWrap={"wrap"}
                w={"100%"}
              >
                <SearchableSelectMulti
                  isShowSearch={false}
                  options={statusDatas}
                  // initialSelectedOption={{
                  //   key: null,
                  //   value: "Trạng thái",
                  // }}
                  placeholder={"Trạng thái"}
                  setValue={setStatus}
                />
                <SearchableSelectMulti
                  isShowSearch={true}
                  options={apartments}
                  // initialSelectedOption={[{ key: 0, value: "Chọn mã căn" }]}
                  placeholder={"Chọn mã căn"}
                  setValue={setApartmentId}
                />
                <SearchableSelectMulti
                  isShowSearch={true}
                  options={projects}
                  // initialSelectedOption={{ key: 0, value: "Chọn dự án" }}
                  placeholder={"Chọn dự án"}
                  setValue={setProjectId}
                />
                <SearchableSelect
                  isShowSearch={true}
                  options={customers}
                  initialSelectedOption={{ key: 0, value: "Chọn khách hàng" }}
                  setValue={setCustomerId}
                />
                <InputGroup w={"100%"} maxW={"275px"} zIndex={zIndex}>
                  <DatePicker
                    selectsRange={true}
                    startDate={startDate}
                    endDate={endDate}
                    dateFormat="dd/MM/yyyy"
                    locale="vi"
                    onChange={(update) => {
                      setDateRange(update);
                    }}
                    onFocus={() => {
                      setZIndex(3);
                    }}
                    onBlur={() => {
                      setZIndex(1);
                    }}
                    isClearable={true}
                    placeholderText="Ngày ký TTKQ từ ngày - đến ngày"
                    className="datePickerStyle"
                  />
                  {!startDate && !endDate && (
                    <InputRightElement pointerEvents="none" h={"44px"}>
                      <Image src={calendarIcon} />
                    </InputRightElement>
                  )}
                </InputGroup>
                <SearchableSelect
                  isShowSearch={true}
                  options={employees}
                  initialSelectedOption={{
                    key: 0,
                    value: "Chọn người chuyển TTKQ",
                  }}
                  setValue={setEmployeeId}
                />
                <SearchableSelect
                  isShowSearch={true}
                  options={saleBlocks}
                  initialSelectedOption={{ key: 0, value: "Chọn khối" }}
                  setValue={setSaleBlockId}
                />
                <SearchableSelect
                  isShowSearch={true}
                  options={saleAreas}
                  initialSelectedOption={{ key: 0, value: "Chọn vùng" }}
                  setValue={setSaleAreaId}
                />
              </Flex>
            </Flex>
          </Flex>
          <Box width={"100%"} height={"100%"}>
            <Skeleton isLoaded={!isLoading && !isRefetching}>
              <TableContainer
                w={"100%"}
                maxH="calc(100vh - 350.5px)"
                overflowY="auto"
              >
                <Table w={"100%"} variant="unstyled">
                  <Thead
                    position="sticky"
                    top="0"
                    zIndex="1"
                    w={"100%"}
                    h={"41px"}
                    color="white"
                    fontWeight="400"
                    backgroundColor="#F9FAFD"
                  >
                    <Tr h={{ base: "41px" }}>
                      {tableData.headers.map((e, index) => {
                        let width = "auto";
                        let textAlign = "auto";
                        if (e.key === "") {
                          width = "2%";
                          textAlign = "center";
                        } else if (e.key === "code") {
                          width = "5%";
                          textAlign = "start";
                        } else if (e.key === "status") {
                          width = "auto";
                          textAlign = "start";
                        } else if (e.key === "apartment") {
                          width = "10%";
                          textAlign = "start";
                        } else if (e.key === "nameApartment") {
                          width = "10%";
                          textAlign = "start";
                        } else if (e.key === "name") {
                          width = "10%";
                          textAlign = "start";
                        } else if (e.key === "price") {
                          width = "10%";
                          textAlign = "end";
                        } else if (e.key === "priceTime") {
                          width = "10%";
                          textAlign = "end";
                        } else if (e.key === "codeProduct") {
                          width = "10%";
                          textAlign = "start";
                        } else {
                          width = "15%";
                          textAlign = "end";
                        }
                        return (
                          <Td
                            p={"16px 16px 8px 16px"}
                            key={index}
                            border={"none"}
                            color={"#51607B"}
                            fontSize={{ base: "14px" }}
                            w={width}
                          >
                            <Box textAlign={"center"} fontWeight={"bold"}>{e.label}</Box>
                          </Td>
                        );
                      })}
                    </Tr>
                  </Thead>
                  <Tbody w={"100%"} h={"100%"}>
                    {tableData.data?.length > 0 ? (
                      tableData.data?.map((e, rowIndex) => {
                        const items = { ...e };
                        delete items.id;
                        delete items.edit;
                        delete items.detail;
                        delete items.statusSalesContract;
                        const keyValues = Object.keys(items);
                        return (
                          <Tr
                            key={rowIndex}
                            h={"72px"}
                            // Nhiều người tham gia làm dòng cao: căn trên + kẻ ngăn
                            // dòng để biết khối người tham gia thuộc giao dịch nào
                            sx={{
                              "& > td": {
                                verticalAlign: "top",
                                borderBottom: "1px solid var(--bg-line-employee)",
                              },
                            }}
                          >
                            <Td
                              p={"16px 0px 8px 16px"}
                              w={"2%"}
                              bg={
                                rowIndex % 2 === 0
                                  ? "var(--color-main)"
                                  : "var(--fill-avatar)"
                              }
                            >
                              <Menu>
                                <MenuButton
                                  _hover={{ backgroundColor: "none" }}
                                  _active={{ backgroundColor: "none" }}
                                  background="none"
                                  as={Button}
                                  p={0}
                                >
                                  <AiOutlineMore fontSize={"20px"} w="20px" />
                                </MenuButton>
                                <MenuList
                                  fontSize={{ base: "14px" }}
                                  fontWeight={500}
                                  lineHeight={"140%"}
                                  color={"var(--color-info-employee)"}
                                >
                                  <MenuItem
                                    gap={"16px"}
                                    onClick={() => handlePopup(false, e)}
                                  >
                                    <Image src={iconDetail} /> Xem chi tiết
                                  </MenuItem>
                                  <MenuItem
                                    gap={"16px"}
                                    onClick={() => handlePopup(true, e)}
                                  >
                                    <Image src={iconEdit} /> Chỉnh sửa
                                  </MenuItem>
                                  <MenuItem
                                    gap={"16px"}
                                    onClick={() => getTypeImage(e?.id)}
                                  >
                                    <Image src={iconArrowLeft} /> Tải ảnh TTKQ
                                  </MenuItem>
                                  <MenuItem
                                    gap={"16px"}
                                    onClick={() =>
                                      handleOpenReportBooking(e?.edit)
                                    }
                                  >
                                    <Image src={iconDetail} /> Phản hồi TTKQ
                                  </MenuItem>
                                  {!e?.statusSalesContract &&
                                    e?.status === StatusData.ttkq.APPROVED && (
                                      <MenuItem
                                        gap={"16px"}
                                        onClick={() => handleHDMB(e)}
                                      >
                                        <Image src={iconArrowLeft} /> Chuyển
                                        HĐMB
                                      </MenuItem>
                                    )}
                                </MenuList>
                              </Menu>
                            </Td>
                            <Td
                              p={"16px 0px 8px 16px"}
                              w={"2%"}
                              bg={
                                rowIndex % 2 === 0
                                  ? "var(--color-main)"
                                  : "var(--fill-avatar)"
                              }
                            >
                              {rowIndex + 1}
                            </Td>
                            {keyValues.map((keyvalue, index) => {
                              let width = "auto";
                              let widthText = "100%";
                              let textAlign = "auto";
                              let whiteSpace = "inherit";
                              if (keyvalue === "") {
                                width = "2%";
                                textAlign = "center";
                              } else if (keyvalue === "code") {
                                width = "5%";
                                textAlign = "start";
                              } else if (keyvalue === "status") {
                                width = "auto";
                                textAlign = "start";
                              } else if (keyvalue === "name") {
                                width = "10%";
                                textAlign = "start";
                                whiteSpace = "normal";
                                widthText = "118px";
                              } else if (keyvalue === "apartment") {
                                width = "10%";
                                textAlign = "start";
                              } else if (keyvalue === "nameApartment") {
                                width = "10%";
                                textAlign = "start";
                              } else if (keyvalue === "price") {
                                width = "10%";
                                textAlign = "end";
                              } else if (keyvalue === "priceTime") {
                                width = "10%";
                                textAlign = "end";
                              } else if (keyvalue === "codeProduct") {
                                width = "10%";
                                textAlign = "start";
                              } else if (
                                keyvalue === "timeDelivery" ||
                                keyvalue === "timeStart" ||
                                keyvalue === "timeEnd"
                              ) {
                                width = "5%";
                              } else {
                                width = "10%";
                                textAlign = "end";
                                whiteSpace = "inherit";
                              }
                              return (
                                <Td
                                  p={"16px 16px 8px 16px"}
                                  w={width}
                                  key={index}
                                  bg={
                                    rowIndex % 2 === 0
                                      ? "var(--color-main)"
                                      : "var(--fill-avatar)"
                                  }
                                >
                                  <Box
                                    fontSize={{ base: "14px" }}
                                    lineHeight={"19.6px"}
                                    textAlign={"start"}
                                    fontWeight={500}
                                    color={"var(--color-info-employee)"}
                                    w={widthText}
                                    whiteSpace={whiteSpace}
                                    overflow="hidden"
                                    textOverflow="ellipsis"
                                    display={
                                      keyvalue === "participants"
                                        ? "block"
                                        : "-webkit-box"
                                    }
                                    sx={{
                                      WebkitLineClamp: "2",
                                      WebkitBoxOrient: "vertical",
                                    }}
                                  >
                                    {keyvalue === "status"
                                      ? formatTableValue(
                                          e[keyvalue],
                                          keyvalue,
                                          e.code,
                                          submitStatus,
                                          e.id,
                                          revertStatus
                                        )
                                      : formatTableValue(
                                          e[keyvalue],
                                          keyvalue,
                                          e.code
                                        )}
                                  </Box>
                                </Td>
                              );
                            })}
                          </Tr>
                        );
                      })
                    ) : (
                      <Tr>
                        <Td
                          colSpan={tableData.headers.length}
                          textAlign="center"
                          padding={"40px 0"}
                        >
                          Không có dữ liệu
                        </Td>
                      </Tr>
                    )}
                  </Tbody>
                </Table>
              </TableContainer>
            </Skeleton>
            <Box mt={10} mr={5} mb={5} ml={5}>
              <Flex alignItems={"center"} justifyContent={"space-between"}>
                <Text>
                  Showing {startEntry} to {endEntry} of {entries} entries
                </Text>
                <HStack spacing={2} justify="flex-end">
                  <ReactPaginate
                    className="pagination-custom"
                    pageCount={totalPages}
                    pageRangeDisplayed={3}
                    marginPagesDisplayed={1}
                    onPageChange={handlePageChange}
                    containerClassName={"pagination"}
                    activeClassName={"active"}
                    breakClassName={"ellipsis"}
                    breakLabel={"..."}
                    previousLabel={
                      <Img
                        w={"16px"}
                        minW={"16px"}
                        h={"16px"}
                        src={chevronLeft}
                      />
                    }
                    nextLabel={
                      <Img
                        w={"16px"}
                        minW={"16px"}
                        h={"16px"}
                        src={chevronRight}
                      />
                    }
                    renderOnZeroPageCount={null}
                    forcePage={currentPage - 1}
                  />
                </HStack>
              </Flex>
            </Box>
          </Box>
        </Flex>
      </Flex>
      {isEdit ? (
        <FormDetail
          isOpen={isOpen}
          onClose={onClose}
          isEdit={true}
          defaultValues={dataEdit}
          onSubmit={onSubmitEdit}
        />
      ) : (
        <FormInfo
          isOpen={isOpen}
          onClose={onClose}
          defaultValues={dataEdit}
          refetch={refetch}
        />
      )}

      <FormCreateSaleContract
        isOpen={isOpenHDMB}
        onClose={onCloseHDMB}
        defaultValues={{
          ttkqId: dataEdit?.id,
          paymentMethodId: dataEdit?.paymentMethodId,
          bookerId: dataEdit?.bookerId,
          customerId: dataEdit?.customerId,
        }}
        onSubmit={onSubmitCreateSaleContract}
      />

      <FormReport
        isOpen={isOpenReport}
        onClose={onCloseReport}
        isEdit={true}
        defaultValues={dataEdit}
        // onSubmit={onSubmitReport}
      />

      <TableTypeImage
        isOpen={isOpenTypeImage}
        onClose={onCloseTypeImage}
        id={dataId || ""}
        defaultValues={typeImage}
      />
    </>
  );
};

const TableTypeImage = memo(({ isOpen, onClose, id, defaultValues }) => {
  const [value, setValue] = useState([]);
  const [dataValue, setDataValue] = useState([]);

  useEffect(() => {
    setValue(defaultValues);
  }, [defaultValues]);

  const downloadPDF = async (id) => {
    const toastCreate = toast.loading("Đang tải ảnh TTKQ ...");
    try {
      const payload = dataValue
        .map((id) => value.find((item) => item.id === id))
        .filter(Boolean);

      const data = await ttkqCall.downloadPDF(id, { input: payload });
      if (data?.fileUrl) {
        const link = document.createElement("a");
        link.target = "_blank";
        link.href = `${baseURL}${data?.fileUrl}`;
        link.click();
        if (document.body.contains(link)) {
          document.body.removeChild(link);
        }
      }
      toast.success("Tải ảnh thành công");
    } catch (error) {
      console.log({ error });
      toast.dismiss(toastCreate);
    }
    toast.dismiss(toastCreate);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent
        backgroundColor="var(--color-main)"
        borderRadius={"16px"}
        position={"relative"}
        w={"100%"}
        maxW={"625px"}
      >
        <Box>
          <Box
            paddingBottom={"80px"}
            h={"86.5vh"}
            w={"100%"}
            sx={{
              "&::-webkit-scrollbar": {
                width: "4px",
              },
              "&::-webkit-scrollbar-thumb": {
                width: "4px",
                borderRadius: "50px",
                background: "var(--color-background)",
              },
              "&::-moz-scrollbar": {
                width: "4px",
              },
              "&::-moz-scrollbar-thumb": {
                width: "4px",
                borderRadius: "50px",
                background: "var(--color-background)",
              },
            }}
          >
            <Flex
              alignItems={"center"}
              p={"25px 24px 24px 24px"}
              position={"relative"}
              borderBottom={"1px solid var(--border-input-employee)"}
            >
              <Text
                color={"var(--color-header-employee)"}
                fontSize={"16px"}
                fontWeight={"600"}
              >
                Danh sách ảnh TTKQ
              </Text>
              <Box
                position={"absolute"}
                top={"24px"}
                right={"24px"}
                cursor={"pointer"}
                onClick={onClose}
              >
                <Image src={IconX} />
              </Box>
            </Flex>
            <Box
              alignItems={"center"}
              p={"25px 24px 24px 24px"}
              position={"relative"}
            >
              {value.map((item, index) => {
                const isChecked = dataValue.includes(item.id);
                return (
                  <Flex
                    key={index}
                    align="center"
                    borderBottom="1px solid var(--border-input-employee)"
                    _hover={{ background: "#f9fafd" }}
                  >
                    <Checkbox
                    p={2}
                      w={"100%"}
                      isChecked={isChecked}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setDataValue((prev) => [...prev, item.id]);
                        } else {
                          setDataValue((prev) =>
                            prev.filter((i) => i !== item.id)
                          );
                        }
                      }}
                    >
                      {item?.name || ""}
                    </Checkbox>
                  </Flex>
                );
              })}
            </Box>
          </Box>
          {dataValue && dataValue?.length > 0 && (
            <Box
              position={"absolute"}
              w={"100%"}
              bottom={"0"}
              bg={"var(--color-main)"}
              borderTop={"0.5px solid var(--bg-line-employee)"}
              borderRadius={"0px 0px 16px 16px"}
              zIndex={3}
            >
              <Flex p={"24px"} gap={"16px"} justifyContent={"flex-end"}>
                <Button
                  w={"112px"}
                  p={"13px 20px"}
                  fontSize={"15px"}
                  fontWeight={600}
                  color={"var(--color-main)"}
                  borderRadius={"8px"}
                  bg={"var(--color-option-employee-hover)"}
                  _hover={{
                    filter: "brightness(90%)",
                  }}
                  onClick={() => downloadPDF(id)}
                >
                  Tải ảnh xuống
                </Button>
              </Flex>
            </Box>
          )}
        </Box>
      </ModalContent>
    </Modal>
  );
});

export default TableOpenTtkq;
